import { useTranslation } from 'react-i18next';

type Country = 'all' | 'JP' | 'VN';

interface Props {
  value: Country;
  onChange: (next: Country) => void;
  className?: string;
}

const OPTIONS: { value: Country; labelKey: string; flag: string }[] = [
  { value: 'all', labelKey: 'common.country.all', flag: '🌐' },
  { value: 'JP',  labelKey: 'common.country.jp',  flag: '🇯🇵' },
  { value: 'VN',  labelKey: 'common.country.vn',  flag: '🇻🇳' },
];

export default function CountryFilter({ value, onChange, className }: Props) {
  const { t } = useTranslation();
  return (
    <div className={`inline-flex rounded-lg border border-warm-gray-300 dark:border-warm-gray-600 overflow-hidden ${className ?? ''}`}>
      {OPTIONS.map(opt => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 text-sm font-medium transition-colors flex items-center gap-1.5 ${
              active
                ? 'bg-amber-600 text-white'
                : 'bg-white dark:bg-warm-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-warm-gray-700'
            }`}
            aria-pressed={active}
          >
            <span>{opt.flag}</span>
            <span>{t(opt.labelKey)}</span>
          </button>
        );
      })}
    </div>
  );
}

export type { Country };
